import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentFooters } from '@models/businesses';
import { BusinessDocumentFooterConfiguration } from '@models/matter';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessState } from '@state/business';

@Component({
	selector: 'app-footer-selector',
	templateUrl: 'footer-selector.component.html',
	standalone: false,
})
export class FooterSelectorComponent {
	@Input() set footerConfiguration(
		footerConfig: BusinessDocumentFooterConfiguration,
	) {
		this.firstPageFooter = footerConfig?.firstPage?.enabled;
		this.allPagesFooter = footerConfig?.allPages?.enabled;
	}

	@ViewSelectSnapshot(BusinessState.getFooter)
	footerGlobalConfig: DocumentFooters;

	@Output() footerConfigurationChange =
		new EventEmitter<BusinessDocumentFooterConfiguration>();

	public firstPageFooter = false;
	public allPagesFooter = false;

	onFirstPageFooterChange(value: boolean) {
		this.firstPageFooter = value;
		this.footerConfigurationChange.emit({
			allPages: { enabled: this.allPagesFooter },
			firstPage: { enabled: this.firstPageFooter },
		});
	}

	onAllPagesFooterChange(value: boolean) {
		this.allPagesFooter = value;
		this.footerConfigurationChange.emit({
			allPages: { enabled: this.allPagesFooter },
			firstPage: { enabled: this.firstPageFooter },
		});
	}
}
